import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        divider: {my: 'medium.base', color: 'background.light'},
        downloadIcon: {height: remCalc(40), width: remCalc(40)},
        dropdownContainer: {width: '100%', maxWidth: remCalc(351)},
        pageContainer: {
            flexDirection: 'column',
            w: '100%',
            gap: {base: remCalc(40), md: remCalc(80)},
            mb: {base: remCalc(40), md: remCalc(80)},
        },
        headingSection: {
            background: 'background.light',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: {base: 'center', lg: 'left'},
            paddingY: {base: 'medium.base', lg: 'medium.lg'},
            paddingX: 'small.base',
            gap: 'medium.base',
        },
        headingTitle: {
            textStyle: 'head-medium',
            fontWeight: 'medium',
            color: 'text.default',
        },
        headingSubtitle: {
            textStyle: 'body-large',
            fontWeight: 'normal',
            color: 'text.default',
        },
        imageContainer: {
            width: '100%',
            maxW: {base: remCalc(133), lg: remCalc(332)},
        },
        loadingBox: {
            position: 'relative',
            marginTop: remCalc(40),
        },
        productSection: {
            width: '100%',
            layerStyle: 'full-width',
            marginX: 'auto',
            flexDirection: {base: 'column', lg: 'row'},
            paddingX: {base: 'small.base', lg: 'small.lg', xl: 'unset'},
            justifyContent: 'space-between',
            gap: {base: 'medium.md', lg: 'medium.base'},
        },
        productInfo: {
            flexDirection: {base: 'row', lg: 'column'},
            gap: {base: 'xsmall.sm', lg: 'medium.base'},
            justifyContent: {base: 'center', lg: 'unset'},
            alignItems: 'center',
        },
        productDetails: {
            flexDirection: 'column',
            gap: 'xsmall.sm',
            textAlign: 'center',
            justifyContent: {base: 'center', lg: 'unset'},
        },
        productDetailsTitle: {
            textStyle: 'head-medium',
            fontWeight: 'medium',
            color: 'text.default',
        },
        productDetailsId: {textStyle: 'body-medium', fontWeight: 'normal', color: 'text.secondary'},
        productManualsContainer: {flexDirection: 'column', gap: remCalc(10)},
        productManualsHeader: {
            flexDirection: {base: 'column', lg: 'row'},
            gap: {base: 'small.base', lg: 'unset'},
            justifyContent: {base: 'center', lg: 'space-between'},
            marginBottom: {base: remCalc(40), lg: remCalc(60)},
            alignItems: 'center',
        },
        productManualsSection: {flexDirection: 'column', width: '100%'},
        productManualCard: {justifyContent: 'space-between'},
        fileLabel: {textStyle: 'body-large', fontWeight: 'normal', color: 'text.default'},
        filesizeText: {textStyle: 'body-small', fontWeight: 'normal', color: 'text.secondary'},
        fileFlex: {
            alignItems: 'center',
        },
        bannerOuterContainer: {
            background: 'background.brand',
            color: 'text.inverse',
            marginX: 'auto',
            maxWidth: remCalc(1654),
        },
        bannerInnerContainer: {
            flexDirection: {base: 'column', lg: 'row'},
            padding: {base: remCalc(16), lg: remCalc(0)},
            gap: remCalc(24),
            w: '100%',
            justifyContent: 'space-between',
        },
        bannerTextStack: {
            flexDirection: 'column',
            textAlign: {base: 'center', lg: 'start'},
            alignItems: {base: 'center', lg: 'flex-start'},
            justifyContent: 'center',
            gap: {base: remCalc(8), lg: remCalc(24)},
            paddingLeft: {base: remCalc(0), lg: remCalc(40)},
            paddingY: {base: remCalc(0), lg: remCalc(104)},
        },
        bannerTitle: {
            textStyle: 'head-medium',
            fontWeight: 'medium',
        },
        bannerDescription: {
            textStyle: 'body-medium',
            fontWeight: 'normal',
        },
        bannerButton: {
            w: remCalc(214),
            h: remCalc(40),
            textDecoration: 'none !important',
        },
        bannerImage: {
            w: {base: '100%', lg: remCalc(569)},
            h: {base: remCalc(210), lg: '100%'},
            objectFit: 'cover',
            order: {base: 0, lg: 1},
            alignSelf: {base: 'flex-start', lg: 'flex-end'},
            mx: {base: 'auto', lg: remCalc(0)},
        },
        productRecallContainer: {
            width: '100%',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'background.light',
            marginY: {base: 'large.base', lg: 'large.lg'},
            py: 'large.base',
            px: 'medium.base',
            gap: 'medium.base',
        },
        recallIcon: {
            width: 'iconsSize.xlarge',
            height: 'iconsSize.xlarge',
            cursor: 'default',
        },
        recallText: {
            color: 'text.default',
            textAlign: 'center',
            textStyle: 'body-medium',
            fontWeight: 'bold',
            width: '100%',
            maxWidth: remCalc(850),
        },
        recallLink: {
            paddingLeft: remCalc(8),
            textStyle: 'body-medium',
            textDecoration: 'underline',
        },
    },
    variants: {
        plpManuals: {
            divider: {my: remCalc(10)},
            fileLabel: {textStyle: 'body-medium', fontWeight: 'normal', color: 'text.default'},
            fileFlex: {
                flexDirection: 'column',
            },
        },
    },
}
